import React, { useState } from 'react';
import classNameBind from 'classnames/bind';
import ActionList from '../../../ActionList';
import Button from '../../../Button';
import Caption from '../../../Caption';
import Checkbox from '../../../Checkbox';
import Icon from '../../../Icon';
import Popover from '../../../Popover';
import Text from '../../../Text';
import Tooltip from '../../../Tooltip';
import StatusIcon from '../StatusIcon';
import styles from './Element.module.css';

const bindClasses = classNameBind.bind(styles);

const Element = ({ id, name, onClick, caption, status, isActive, checkbox, isFavorite, leftIcon, rightIcons = [], actionsPopover, nestingLvl = 0 }) => {
  const [popoverOpened, setPopoverOpened] = useState(false);

  return (
    <div
      className={bindClasses('wrapper', { active: isActive, hover: popoverOpened })}
      data-ppuc-id="Sidebar.Element"
    >
      {checkbox && (
        <div className={bindClasses('checkbox-wrapper', { selected: checkbox.checked })}>
          <Checkbox
            name={`checkbox_${id}`}
            id={`checkbox_${id}`}
            dataId={`Sidebar.Element.Checkbox_${id}`}
            checked={checkbox.checked}
            onChange={() => {
              checkbox.onSelect(id);
            }}
          />
        </div>
      )}
      {status && (
        <button
          type="button"
          className={bindClasses('status-icon', { active: isActive })}
          data-ppuc-id="Sidebar.Element.StatusIcon"
          disabled={status.disabled}
          onClick={status.onClick}
        >
          <StatusIcon type={status.type} color={status.color} tooltip={status.tooltip} />
        </button>
      )}
      <div
        className={bindClasses('flex-text')}
        style={{ paddingLeft: `${nestingLvl * 24 - (nestingLvl ? 2 : 0) - (status && nestingLvl ? 24 : 0)}px` }}
        onClick={() => { onClick(id); }}
        role="button"
        tabIndex={0}
      >
        <Tooltip content={name} position="top-start" hideSpeechBubble>
          <div className={bindClasses('element-main')}>
            {leftIcon && (
              <Icon
                name={leftIcon}
                size="default"
                className={bindClasses('element-main-icon')}
                color="black"
              />
            )}
            <Text dataId="Sidebar.Element.Name">
              {name}
            </Text>
          </div>
        </Tooltip>
      </div>
      {caption && (
        <div
          onClick={() => { onClick(id); }}
          role="button"
          tabIndex={0}
        >
          <Caption subdued dataId="Sidebar.Element.Caption">
            {caption}
          </Caption>
        </div>
      )}
      {(rightIcons || isFavorite) && (
        <div className={bindClasses('right-icons')}>
          {rightIcons.map(icon => (
            <div key={icon.name} className={bindClasses('icon')}>
              <Tooltip {...icon.tooltip}>
                <Icon name={icon.name} color="black" />
              </Tooltip>
            </div>
          ))}
          {isFavorite && (
            <div className={bindClasses('icon')} data-ppuc-id="Sidebar.Element.Favorite">
              <Icon name="star" color="yellow" />
            </div>
          )}
        </div>
      )}
      {actionsPopover && (
        <Popover
          position="bottom"
          onOpen={() => setPopoverOpened(true)}
          onClose={() => setPopoverOpened(false)}
          activatorElement={
            (
              <div className={bindClasses('options-button')}>
                <Button
                  icon="actions"
                  onClick={() => {}}
                  appearance="subdued"
                  dataId="Sidebar.Element.ActionsButton"
                  size="small"
                />
              </div>
            )
          }
          subdued={false}
          hoverTrigger={false}
          noPadding
        >
          {close => (
            <Popover.Section padding="narrow">
              <ActionList
                dataId="Sidebar.Element.Actions"
                groups={actionsPopover.groups}
                onItemSelected={(event) => {
                  actionsPopover.onItemSelected(event);
                  close();
                }}
              />
            </Popover.Section>
          )}
        </Popover>
      )}
    </div>
  );
};

Element.displayName = 'Sidebar.Element';

export default Element;
